import { render, staticRenderFns } from "./upload-button.html?vue&type=template&id=b613b5be&scoped=true&"
import script from "./upload-button.js?vue&type=script&lang=js&"
export * from "./upload-button.js?vue&type=script&lang=js&"
import style0 from "./upload-button.scss?vue&type=style&index=0&id=b613b5be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b613b5be",
  null
  
)

export default component.exports